import { render, staticRenderFns } from "./setMaklumatPegSeb2003.vue?vue&type=template&id=2ff86b98&"
import script from "./setMaklumatPegSeb2003.vue?vue&type=script&lang=js&"
export * from "./setMaklumatPegSeb2003.vue?vue&type=script&lang=js&"
import style0 from "./setMaklumatPegSeb2003.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports